export enum CalculatorViewChoice {
  KtShoot = 'KtShoot',
  KtFight = 'KtFight',
  KtShootMassAnalysis = 'KtShootMassAnalysis',
  WorldOfTanks = "WorldOfTanks",
  Deadzone = "Deadzone",
  HaloFlashpoint = "HaloFlashpoint",
}
